export { default } from './PlatformLink';
